// extracted by mini-css-extract-plugin
module.exports = {"secure":"_131048f"};